import { VoiceType } from '../types'

const LANGUAGE = [
  'English',
  'Spanish',
  'Portugese',
  'Chinese',
  'Russian',
  'German',
  'Arabic',
  'Hindi',
  'Japanese',
  'Italian',
  'French',
  'Korean',
  'Other'
] as const

const STYLE = ['Rapping', 'Singing', 'Speaking', 'Instrument'] as const

const VOICE = [VoiceType.RAPPING, VoiceType.SINGING, VoiceType.SPEAKING] as const

const GENRE = ['Pop', 'R&B', 'Rock', 'Electronic', 'Global', 'Jazz'] as const

const GENDER = ['Male', 'Female']

export const OFFICIAL_KITS_TAGS = {
  LANGUAGE,
  VOICE,
  STYLE,
  GENRE,
  GENDER
}
